// custom.js

const DESKTOP_MEDIA_QUERY = '(min-width: 1000px)';

function initVideoLoadedHandler(root = document) {
  if (!root || !root.querySelectorAll) {
    return;
  }

  const videos = root.querySelectorAll('video-media > video');
  videos.forEach((video) => {
    if (video.dataset.videoLoadedHandlerAttached === 'true') {
      return;
    }

    video.dataset.videoLoadedHandlerAttached = 'true';
    video.addEventListener('ended', () => {
      const parent = video.closest('video-media');
      if (parent) {
        parent.addEventListener('click', (evt) => {
          parent.setAttribute('loaded', 'loaded');
          parent.play(true)
        });
        if (parent.hasAttribute('loaded')) {
          parent.removeAttribute('loaded');
        }
      }
    });
  });
}

function setupScrollableMultiColumn(wrapper) {
  if (!wrapper || wrapper.dataset.scrollableMultiColumn !== 'true') {
    return;
  }

  if (wrapper.__scrollableInitialized) {
    return;
  }

  const mediaQuery = window.matchMedia ? window.matchMedia(DESKTOP_MEDIA_QUERY) : null;
  const container = wrapper.querySelector('[data-scrollable-container]');
  const items = container ? Array.from(container.querySelectorAll('[data-scroll-index]')) : [];

  if (!container || !items.length) {
    return;
  }

  const prevButton = wrapper.querySelector('[data-scrollable-prev]');
  const nextButton = wrapper.querySelector('[data-scrollable-next]');
  const visibleCount = parseInt(wrapper.getAttribute('data-visible-count') || '0', 10);

  if (!prevButton && !nextButton) {
    return;
  }

  wrapper.__scrollableInitialized = true;

  let startIndex = 0;
  let endIndex = Math.min(
    visibleCount > 0 ? visibleCount - 1 : items.length - 1,
    items.length - 1,
  );

  const updateButtons = () => {
    if (prevButton) {
      prevButton.disabled = startIndex <= 0 || (mediaQuery && !mediaQuery.matches);
    }
    if (nextButton) {
      nextButton.disabled = endIndex >= items.length - 1 || (mediaQuery && !mediaQuery.matches);
    }
  };

  const scrollToItem = (item, align = 'start') => {
    if (!item) {
      return;
    }
    item.scrollIntoView({
      behavior: 'smooth',
      inline: align,
      block: 'nearest',
    });
  };

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      if (endIndex >= items.length - 1) {
        return;
      }
      startIndex = Math.min(startIndex + 1, items.length - 1);
      endIndex = Math.min(endIndex + 1, items.length - 1);
      scrollToItem(items[endIndex], 'end');
      updateButtons();
    });
  }

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      if (startIndex <= 0) {
        return;
      }
      startIndex = Math.max(startIndex - 1, 0);
      endIndex = Math.max(endIndex - 1, visibleCount > 0 ? visibleCount - 1 : 0);
      scrollToItem(items[startIndex], 'start');
      updateButtons();
    });
  }

  if (mediaQuery) {
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', updateButtons);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(updateButtons);
    }
  }

  updateButtons();
}

function initScrollableMultiColumns(root = document) {
  if (!root || !root.querySelectorAll) {
    return;
  }

  const wrappers = root.querySelectorAll('[data-scrollable-multi-column="true"]');
  wrappers.forEach((wrapper) => setupScrollableMultiColumn(wrapper));
}

function runInitializers(root = document) {
  initVideoLoadedHandler(root);
  initScrollableMultiColumns(root);
}

// --- Export all functions for optional import use ---
export {
  initVideoLoadedHandler,
  initScrollableMultiColumns,
  runInitializers,
};

// --- Auto-run initialization once DOM is ready ---
document.addEventListener('DOMContentLoaded', () => runInitializers(document));

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target || (event.detail && document.getElementById(`shopify-section-${event.detail.sectionId}`));
  if (section) {
    runInitializers(section);
  }
});
